<template>
    <div class="relative about-us">
        <div class="xl:w-2/5 lg:w-1/2 w-full p-4 lg:p-0 mx-auto text-lg leading-normal font-light text-justify">
            <div class="self-center font-fira text-black end-slogan flex w-full">
                <h1 class="ml-1 text-4xl font-hairline rotate">Amit</h1>
                <div class="-ml-8">
                    <h2 class="text-4xl font-normal uppercase ml-2">rólunk</h2>
                    <h2 class="ml-8 -mt-4 text-4xl font-hairline scrollabout">tudni <span
                            class="font-normal">érdemes</span></h2>
                </div>
            </div>

            <p class="mb-8 font-light text-base">A VISUALZ Creative Studio-t azzal a céllal keltettük életre a digitális
                ügynökségek dzsungelében, hogy valódi, professzionális megoldást kínáljunk kis és középvállalkozók
                számára online és offline megjelenésükhöz egyaránt. Szemléletünk szerint minden partnerünket az
                ügynökségeknél megszokott teljeskörű kiszolgálásban részesítjük, mindezt személyesebb, együttműködő
                kapcsolatban, kifogástalan minőségben és reális áron.
            </p>
            <p class="mb-8 font-light text-base">
                Küldetésünk a modern design és a legújabb technológiák ötvözésével színt vinni a vállalkozások életébe,
                ezáltal növelve a hatékonyságát és eredményességét. Bennünk egy kreatív és innovatív csapatra találsz.

            </p>
            <p class="font-light text-base">
                Széleskörű termék és szolgáltatás palettánkból biztosan megtalálod azt, amire szükséged van, hogy
                naprakész legyél a weben, az irodában, egy konferencián vagy bárhol a világon.
            </p>
        </div>
        <img class="dorka absolute pin-b ppl" src="../assets/Dorka_2.png">
        <img class="gabor absolute pin-b ppl" src="../assets/Gabor_2.png">
    </div>
</template>

<script>
export default {
  name: 'Aboutus'
}
</script>

<style lang="scss" scoped>
    .dorka {
        right: 50px;
        z-index: 2;
        @media (max-width: 576px) {
            right: 10px;
        }
    }

    .gabor {
        left: 50px;
        @media (max-width: 576px) {
            left: 10px;
        }
    }

    .ppl {
        width: 400px;
        @media (max-width: 1200px) {
            width: 200px;
        }
        @media (max-width: 992px) {
        }
    }

    .about-us {
        margin-top: 100px;
        padding-bottom: 300px;
        @media (max-width: 1200px) {
            padding-bottom: 100px;
        }
        @media (max-width: 992px) {
            padding-bottom: 300px;
        }
    }

    .rotate {
        transform: rotate(-90deg);
    }

    .end-slogan {
        margin-right: 200px;
        margin-bottom: 50px
    }

</style>



// WEBPACK FOOTER //
// src/components/Aboutus.vue